import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PageSpinner } from 'src/components/spinner-container';
import {
  RemitReportingLookupContextProvider,
  useRemitReportingLookups,
} from 'src/pages/reporting/secondary-tradings/external-trades/common';
import { ExternalTradeDetails } from 'src/pages/reporting/secondary-tradings/external-trades/details';
import { ExternalTradeEdit } from 'src/pages/reporting/secondary-tradings/external-trades/edit';
import { ExternalTradeWizard } from 'src/pages/reporting/secondary-tradings/external-trades/wizard';
import {
  isRemitReportingSubscriptionInfoLoaded,
  useRemitReportingSubscriptionInfo,
} from 'src/pages/reporting/secondary-tradings/overview/use-remit-reporting-subscription-info';
import { Forbidden } from 'src/utils/errors';

export const ExternalTradesEntry: FC<{}> = ({}) => {
  const subscriptionInfoRequest =
    useRemitReportingSubscriptionInfo('SECONDARY');
  const lookups = useRemitReportingLookups();

  if (!lookups) return <PageSpinner />;

  if (!isRemitReportingSubscriptionInfoLoaded(subscriptionInfoRequest))
    throw new Forbidden();

  return (
    <RemitReportingLookupContextProvider value={lookups}>
      <Switch>
        <Route path="/reporting/secondary/external-trades/wizard">
          <ExternalTradeWizard />
        </Route>
        <Route
          path="/reporting/secondary/external-trades/:externalTradeId"
          exact
        >
          <ExternalTradeDetails />
        </Route>
        <Route path="/reporting/secondary/external-trades/:externalTradeId/edit">
          <ExternalTradeEdit />
        </Route>
        <Redirect to="/reporting/secondary/external-trades" />
      </Switch>
    </RemitReportingLookupContextProvider>
  );
};
